<template>
  <v-container>
    <v-row>
      <v-col
        v-for="element in cardsInfo"
        v-if="currSubStepInStep2===1"
        :key="element.id"
        cols="12"
        sm="6"
        md="8"
        lg="4"
      >
        <!-- cron cards list START -->
        <trigger-cron-card
          :card-info="element"
          :curr-sub-step="currSubStepInStep2"
          :trigger="trigger"
          @click.native="clickedOn(element)"
          @sendTriggerState="updateTrigger"
        />
        <!-- cron cards list END -->
      </v-col>
    </v-row>
    <v-row justify="center">
      <!-- selected cron card START -->
      <v-col
        v-if="currSubStepInStep2===2"
        cols="12"
        sm="8"
        md="8"
        lg="4"
      >
        <trigger-cron-card
          :card-info="chosen"
          :curr-sub-step="currSubStepInStep2"
          :curr-step="currStep"
          :trigger="trigger"
          @sendTriggerState="updateTrigger"
        />
      </v-col>
      <!-- selected cron card END -->
    </v-row>
  </v-container>
</template>

<script>
  import TriggerService from './services/TriggerService'
  import TriggerCronCard from './Cards/TriggerCronCard.vue'

  export default {
    components: {
      TriggerCronCard,
    },

    props: {
      currStep: Number,
      currSubStep: Number,
      trigger: {},
    },
    data: function () {
      return {
        chosen: '',
        currSubStepInStep2: this.currSubStep,
        cardsInfo: [
          {
            id: '1',
            freq: 'HOUR',
            title: 'Every hour at',
            text: 'This Trigger fires once an hour at :00, :15, :30, or :45 minutes past the hour.',
          },
          {
            id: '2',
            freq: 'DAY',
            title: 'Every day at',
            text: 'This Trigger fires every single day at a specific time set by you.',
          },
          {
            id: '3',
            freq: 'WEEK',
            title: 'Every chosen day of the week at',
            text: 'This Trigger fires only on specific days of the week at the time you provide.',
          },
          {
            id: '4',
            freq: 'MONTH',
            title: 'Every month on the',
            text: 'This Trigger fires every month on the day and time you specify.',
          },
          {
            id: '5',
            freq: 'YEAR',
            title: 'Every year on',
            text: 'This Trigger fires once a year on the date and time you specify.',
          },
        ],
      }
    },
    watch: {
      currSubStep: function () {
        this.currSubStepInStep2 = this.currSubStep
      },
    },
    methods: {
      clickedOn (chosenCard) {
        this.currSubStepInStep2 = 2
        this.chosen = chosenCard

        this.trigger.freq_choice = chosenCard.freq
        this.$emit('nextStep')
        this.$emit('sendTriggerState', this.trigger)
      },
      updateTrigger (newTriggerState) {
        this.trigger = newTriggerState
        this.$emit('sendTriggerState', this.trigger)
      },
    },
  }

</script>
